export default "__VITE_ASSET__BgmI3voI__"